export default __webpack_public_path__ + "static/media/pajucara3.0c93dd67.png";